export enum TaskPurposeType {
  Pickup = "Pickup",
  Dropoff = "Dropoff",
  Operation = "Operation",
  StartRoute = "StartRoute",
  EndRoute = "EndRoute",
  StartDay = "StartDay",
  EndDay = "EndDay",
  Break = "Break",
  PickupAndDropoff = "PickupAndDropoff"
}
